var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ReactiveModal",
    {
      staticClass: "modal_plan-task plan-task",
      attrs: { id: "task-list-modal", title: "Список проектных задач" },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
      scopedSlots: _vm._u(
        [
          _vm.hideHeaderBtn
            ? {
                key: "left-actions",
                fn: function () {
                  return [_c("div")]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm.urlTasks.length
        ? _vm._l(_vm.urlTasks, function (urlTask) {
            return _c("div", [
              _c(
                "div",
                { staticClass: "icon-text" },
                [
                  _vm.isAccessAllow
                    ? _c("Icon", {
                        attrs: { id: "delete", color: "purple" },
                        on: {
                          click: function ($event) {
                            return _vm.confirmDelete(urlTask)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.openTask(urlTask)
                        },
                      },
                    },
                    [_vm._v(_vm._s(urlTask.name))]
                  ),
                ],
                1
              ),
            ])
          })
        : _c("p", [_vm._v("Пока нет проектных задач")]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }